﻿import angular from 'angular';

angular.module('folkeuni').component('search', {
    transclude: true,
    templateUrl: '/shop-dist/templates/search.html',
    bindings: {
        searchpage: '@'
    },
    controller: function ($window) {
        var $ctrl = this

        $ctrl.searchbarSubmit = function () {
            if ($ctrl.searchpage) {
                var searchQuery = $ctrl.search;
                $window.location.href = $ctrl.searchpage + '?method=content&query=' + searchQuery;
            }
            else {
                console.log('Søgningen gav ingen resultat');
            }
        }
    }
});